module.exports = __webpack_public_path__ + "static/DishonorWebCover_LARGE-c56e08504f27728538ae6126f3215be5.jpeg";